var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QuotationHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขใบเสนอราคา","link_back":"stock/quotation/quotationmain"}}),_c('Quotation_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }